// src/utils/intercom.js
import Intercom from "@intercom/messenger-js-sdk";

const APP_ID = "or8u1ybp";

export const initIntercom = async () => {
  console.log("🚀 Booting Intercom anonymously");
  Intercom({ app_id: APP_ID });
};

export const identifyIntercomUser = (userData) => {
  if (!userData?.id) {
    console.warn("❌ identifyIntercomUser skipped - no user id");
    return;
  }
  console.log("userData---------->", userData);

  const payload = {
    app_id: APP_ID,
    user_id: String(userData.id),
    name: userData.name || "",
    email: userData.email || "",
    current_company: userData.company,
    rail: userData.rail || "",
    phone: userData.phone,
    App_Platform: "CUPI_ADMIN",
  };

  console.log("📤 identifyIntercomUser →", payload);

  try {
    Intercom(payload);
    console.log("✅ Intercom identify sent successfully");
  } catch (err) {
    console.error("❌ Intercom identify failed:", err);
  }
};

export const updateIntercomUser = (attributes) => {
  console.log("🔄 Updating Intercom attributes:", attributes);
  Intercom("update", attributes);
};

export const shutdownIntercom = () => {
  console.log("User Logged OUT Data Removed");

  function generateUUID() {
    return crypto.randomUUID();
  }
  const payload = {
    app_id: APP_ID,
    user_id: generateUUID(),
    name: "",
    email: "",
    current_company: "",
    rail: "",
    phone: "",
    App_Platform: "CUPI_ADMIN",
  };
  Intercom(payload);
};
